//This is a general configuration file. Use this to make changes to the JS enviroment upon initialization.
import marked from 'marked';
marked.setOptions({sanitize: true});



/** WEBPACK FOOTER **
 ** ./js/app/options.js
 **/